import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { TabViewModule } from "@bfx/primeng/tabview";
import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxInterfaceControlsModule } from "../bfx-interface-controls/bfx-interface-controls.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxGeneralSettingsComponent } from "./bfx-general-settings.component";
import { BfxNotificationSettingsEmailSmsComponent } from "./bfx-notification-settings-emailsms.component";
import { BfxNotificationSettingsComponent } from "./bfx-notification-settings.component";
import { BfxOrderBlotterSettingsPreferencesComponent } from "./bfx-order-blotter-settings-preferences.component";
import { BfxOrderBlotterSettingsTemperatureComponent } from "./bfx-order-blotter-settings-temperature.component";
import { BfxOrderBlotterSettingsComponent } from "./bfx-order-blotter-settings.component";
import { BfxOrderEntrySettingsAlgoComponent } from "./bfx-order-entry-settings-algo.component";
import { BfxOrderEntrySettingsComponent } from "./bfx-order-entry-settings.component";
import { BfxPanicControlsComponent } from "./bfx-panic-controls-settings.component";
import { BfxTradeBlotterSettingsPeferencesComponent } from "./bfx-trade-blotter-settings-preferences.component";
import { BfxTradeBlotterSettingsComponent } from "./bfx-trade-blotter-settings.component";
import { BfxBmarkSummarySettingsPeferencesComponent } from "./bfx-bmark-summary-settings-preferences.component";
import { BfxBmarkSummarySettingsComponent } from "./bfx-bmark-summary-settings.component";
import { BfxUserSettingsComponent } from "./bfx-user-settings.component";
import { BfxUserSettingsService } from "./bfx-user-settings.service";
import { BfxOrderEntryDefaultsService } from "./support/bfx-order-entry-defaults.service";
import { BfxOrderEntrySettingsNDFComponent } from "./bfx-order-entry-settings-ndf.component";
import { BfxOrderEntrySettingsBmarkComponent } from "./bfx-order-entry-settings-bmark.component";
import { BfxOrderEntrySettingsSpotComponent } from "./bfx-order-entry-settings-spot.component";
import { BfxOrderEntrySettingsPreferencesComponent } from "./bfx-order-entry-settings-preferences.component";
import { BfxOrderEntrySettingsGammaComponent } from "./bfx-order-entry-settings-gamma.component";

// perfect scrollbar
/***********************/
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { ICControlsModule } from "../ic-controls/ic-controls.module";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { AgGridModule } from "@bfx/ag-grid-angular";
import { BfxOrderEntrySettingsNDFAlgoComponent } from "./bfx-order-entry-settings-ndf-algo.component";
import { BfxNotificationSettingsLimitComponent } from "app/bfx-user-settings/bfx-notification-settings-limit.component.";
import { BfxNotificationSettingRowComponent } from "app/bfx-user-settings/bfx-notification-setting-row.component";
import { BfxUserNotificationSettingsService } from "app/bfx-user-settings/services/bfx-user-notification-settings.service";
import { BfxNotificationSettingsAlgoComponent } from "app/bfx-user-settings/bfx-notification-settings-algo.component";
import { BfxNotificationSettingsBMarkComponent } from "app/bfx-user-settings/bfx-notification-settings-bmark.component";
import { BfxNotificationSettingsGeneralComponent } from "app/bfx-user-settings/bfx-notification-settings-general.component";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
/* BFX */
// modules
// components

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    BfxSharedModule,
    TranslateModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    TabViewModule,
    AutoCompleteModule,
    PerfectScrollbarModule,
    FlexLayoutModule,
    BfxElementsLibraryModule,
    BfxInterfaceControlsModule,
    NativeDesktopModule,
    CheckboxModule,
    DropdownModule,
    ICControlsModule,
    BaseComponentsModule,
    AgGridModule.withComponents([]),
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxUserSettingsService,
    BfxOrderEntryDefaultsService,
  ],
  declarations: [
    BfxUserSettingsComponent,
    BfxGeneralSettingsComponent,
    BfxOrderBlotterSettingsComponent,
    BfxTradeBlotterSettingsComponent,
    BfxBmarkSummarySettingsComponent,
    BfxOrderBlotterSettingsPreferencesComponent,
    BfxTradeBlotterSettingsPeferencesComponent,
    BfxBmarkSummarySettingsPeferencesComponent,
    BfxOrderBlotterSettingsTemperatureComponent,
    BfxNotificationSettingsComponent,
    BfxPanicControlsComponent,
    BfxNotificationSettingRowComponent,
    BfxNotificationSettingsEmailSmsComponent,
    // order entery components
    BfxOrderEntrySettingsComponent,
    BfxOrderEntrySettingsAlgoComponent,
    BfxOrderEntrySettingsNDFAlgoComponent,
    BfxOrderEntrySettingsNDFComponent,
    BfxOrderEntrySettingsBmarkComponent,
    BfxOrderEntrySettingsSpotComponent,
    BfxOrderEntrySettingsGammaComponent,
    BfxOrderEntrySettingsPreferencesComponent,
    BfxNotificationSettingsLimitComponent,
    BfxNotificationSettingsAlgoComponent,
    BfxNotificationSettingsBMarkComponent,
    BfxNotificationSettingsGeneralComponent,
  ],
  exports: [
    BfxUserSettingsComponent,
    BfxGeneralSettingsComponent,
    BfxOrderBlotterSettingsComponent,
    BfxTradeBlotterSettingsComponent,
    BfxBmarkSummarySettingsComponent,
    BfxNotificationSettingsComponent,
    BfxOrderEntrySettingsComponent,
  ],
  bootstrap: [BfxUserSettingsComponent],
})
export class BfxUserSettingsModule {}
